module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-about-meet-team__wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hovered),
      expression: "!hovered"
    }],
    staticClass: "custom-about-meet-team__img",
    on: {
      "mouseover": function($event) {
        _vm.hovered = true
      }
    }
  }, [(_vm.slide.img != '') ? _c('img', {
    attrs: {
      "src": _vm.slide.img
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.img_placeholder,
      "alt": ""
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hovered),
      expression: "hovered"
    }],
    staticClass: "custom-about-meet-team__img",
    on: {
      "mouseleave": function($event) {
        _vm.hovered = false
      }
    }
  }, [(_vm.slide.img_silly != '') ? _c('img', {
    attrs: {
      "src": _vm.slide.img_silly
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.img_placeholder,
      "alt": ""
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f133b08","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-image-swap/custom-image-swap.pug
// module id = 561
// module chunks = 1